import React from 'react'
import { Link } from 'react-router-dom';
import "../../assets/styles/home.css";
import doctor from '../../assets/images/undraw_medical_care_movn.svg'

function Home() {
  return (
    <section className="hero is-fullheight-with-navbar home-div">

      <div className="hero-body">
        <div className="container">
          <div className="columns is-vcentered">

            <div className="column is-5">
              <h1 className="title is-1 is-light is-semibold is-spaced main-title has-text-black has-text-centered">Mediary</h1>
              <h2 className="subtitle is-3 is-light is-thin has-text-black has-text-centered">
                Personal Medical Record System
              </h2>

              <div className="buttons">
                {(localStorage.getItem("x-auth-token")) && (
                  <Link to="/dashboard"><button className="button is-success">Go to the Dashboard</button></Link>
                )}
              </div>
            </div>

            <div className="column is-7">
              <div className='is-flex is-justify-content-center'>
                <img src={doctor} alt="Doctor SVG" style={{ width: '80%' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Home